
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ActionButtonsProps {
  showRedirectButton: boolean;
  isUpdating: boolean;
  error: string | null;
  onManualRedirect: () => void;
}

export const ActionButtons = ({ 
  showRedirectButton, 
  isUpdating, 
  error, 
  onManualRedirect 
}: ActionButtonsProps) => {
  if (!showRedirectButton && isUpdating) return null;

  return (
    <div className="flex flex-col gap-4">
      {(showRedirectButton || !isUpdating) && (
        <Button onClick={onManualRedirect} className="flex items-center justify-center gap-2">
          Go to Dashboard
          <ArrowRight className="h-4 w-4" />
        </Button>
      )}
      
      {(showRedirectButton || !isUpdating) && (
        <Button variant="outline" asChild>
          <Link to="/refund">Create a Refund Request</Link>
        </Button>
      )}
      
      {error && (
        <Button variant="outline" onClick={() => window.location.reload()}>
          Retry
        </Button>
      )}
    </div>
  );
};
